import axios from 'axios';
import {
  V1_NEW_URL,
  UPLOAD_NEW_FILE_URL,
  UPLOAD_NEW_IMAGE_URL,
} from './constants';
import {
  serviceUploadFileErrorCallback,
  serviceUploadImageErrorCallback,
} from '../callbacks';

export function getNew(params) {
  return axios
    .get(V1_NEW_URL, { params, withCredentials: true })
    .catch(error => {
      return Promise.reject(new Error(error.message));
    });
}

export function postNewFile(data) {
  return axios
    .post(UPLOAD_NEW_FILE_URL, data)
    .catch(serviceUploadFileErrorCallback);
}

export function postNewImage(data, header) {
  return axios
    .post(UPLOAD_NEW_IMAGE_URL, data, { headers: header })
    .catch(serviceUploadImageErrorCallback);
}
